<template>
  <span class="customer-highlighted-name">
    <span v-if="isBusiness">
      <i class="mdi mdi-domain"></i>
      <span>{{ businessName }}</span>
    </span>
    <span v-else>
      <template v-if="passedAway">
        (&dagger; Overleden)
      </template>
      <i class="mdi mdi-account"></i>
      <span>{{ initials }}</span>
      <span>{{ suffix }}</span>
      <span>{{ lastName }}</span>
      <template v-if="hasFirstName">
        (<span>{{ firstName }}</span>)
      </template>
      <template v-if="isNonResident">
        (Uitwonend)
      </template>
      <span v-if="hasAge" class="faded">
        - {{ age }} jaar
      </span>
    </span>
  </span>
</template>

<script>
export default {
  name: "CustomerHighlightedNameComponent",
  props: {
    customer: {
      type: Object,
      required: true
    },
    showFirstName: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data() {
    return {};
  },
  computed: {
    isBusiness() {
      return this.customer.is_business;
    },
    businessName() {
      return this.hasAttributeHighlight("business_name")
          ? this.getAttributeHighlight("business_name")
          : this.customer.business_name;
    },
    passedAway() {
      return this.customer.passed_away;
    },
    hasFirstName() {
      return this.customer.first_name !== null && this.customer.first_name.length > 0 && this.showFirstName;
    },
    hasAge() {
      return this.customer.age !== null && this.customer.age > 0;
    },
    age() {
      return this.customer.age;
    },
    isNonResident() {
      return this.customer.non_resident;
    },
    initials() {
      return this.hasAttributeHighlight("initials") ? this.getAttributeHighlight("initials") : this.customer.initials;
    },
    suffix() {
      return this.hasAttributeHighlight("suffix") ? this.getAttributeHighlight("suffix") : this.customer.suffix;
    },
    lastName() {
      return this.hasAttributeHighlight("last_name") ? this.getAttributeHighlight("last_name") : this.customer.last_name;
    },
    firstName() {
      return this.hasAttributeHighlight("first_name") ? this.getAttributeHighlight("first_name") : this.customer.first_name;
    },
    highlight() {
      if (
        typeof this.customer.highlight !== "undefined"
        && this.customer.highlight !== null
        && typeof this.customer.highlight.data !== "undefined"
        && this.customer.highlight.data !== null
      ) {
        return this.customer.highlight.data;
      }

      return {};
    }
  },
  methods: {
    hasAttributeHighlight(attribute) {
      return typeof this.highlight[attribute] !== "undefined" && this.highlight[attribute] !== null;
    },
    getAttributeHighlight(attribute) {
      return this.highlight[attribute][0];
    }
  }
};
</script>

<style scoped>
.faded {
  opacity: 0.5;
}
</style>
